/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Sub_Items_Timeline_HintInputs */

const en_disp_sub_items_timeline_hint = /** @type {(inputs: Disp_Sub_Items_Timeline_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show children under their epic or parent.`)
};

const de_disp_sub_items_timeline_hint = /** @type {(inputs: Disp_Sub_Items_Timeline_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untervorgänge unter ihrem Epic oder übergeordneten Vorgang zeigen.`)
};

/**
* | output |
* | --- |
* | "Show children under their epic or parent." |
*
* @param {Disp_Sub_Items_Timeline_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_sub_items_timeline_hint = /** @type {((inputs?: Disp_Sub_Items_Timeline_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Sub_Items_Timeline_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_sub_items_timeline_hint(inputs)
	return en_disp_sub_items_timeline_hint(inputs)
});